export const regularExpressions = {
    PHONE_NUMBER_PATTERN: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
};



// WEBPACK FOOTER //
// ./src/Constants/regularExpressions.js